import utils from 'utils';

class nav {
  constructor(nav) {
    this.nav = nav;
    this.html = document.documentElement;
    this.navBurger = document.querySelector('.main-nav-burger');
    this.navMainListWrapper = this.nav.querySelector('.main-nav-list-wrapper');
    this.navMainList = this.nav.querySelector('.main-nav-list');
    this.navMainListItem = this.nav.querySelectorAll('.main-nav-list-item');
    this.navSubLinks = this.nav.querySelectorAll('.main-nav-link-has-sub');
    this.navSubPanels = this.nav.querySelectorAll('.main-nav-sub');
    this.region = this.nav.querySelectorAll('.region');
    this.regionListWrapper = this.nav.querySelector('.region-list-wrapper');
    if (this.regionListWrapper) {
      this.regionListWrapperHeight = utils.outerHeight(this.regionListWrapper);
    }
    // this.regionListWrapperHeight = utils.outerHeight(this.regionListWrapper);
    this.regionList = this.nav.querySelector('.region-list');
    if (!this.regionList) {
      return;
    }
    this.regionListItem = this.regionList.querySelectorAll('.region-list-item');
    this.region = this.nav.querySelectorAll('.region');
    this.events();
  }

  events() {
    this.regionMap();
    this.resetNav();

    for (let regionItem of this.regionListItem) {
      regionItem.addEventListener('click', e => {
        this.regionListToggle(regionItem);
      });
    }

    for (let navSubLink of this.navSubLinks) {
      navSubLink.addEventListener('click', e => {
        this.navToggle(navSubLink);
      });
    }

    this.navBurger.addEventListener('click', e => {
      e.stopPropagation();
      this.burgerToggle();
    });

    this.html.addEventListener('click', e => {
      this.resetNav();
    });

    this.navMainListWrapper.addEventListener('click', e => {
      e.stopPropagation();
    });

    if (!utils.mq.md.matches) {
      this.regionListToggle(this.regionList.firstElementChild);
    }

    utils.mq.md.addEventListener('change', mq => {
      if (!utils.mq.md.matches) {
        this.resetNav();
        this.regionListToggle(this.regionList.firstElementChild);
      }
      else {
        this.resetNav();
      }
    });
  }

  resetNav() {
    this.activeElems = this.navMainList.querySelectorAll('.active');
    this.inactiveElems = this.navMainList.querySelectorAll('.inactive');

    this.html.classList.remove('o-h');
    this.navBurger.classList.remove('active');
    this.navMainListWrapper.classList.remove('active');

    for (let activeElem of this.activeElems) {
      activeElem.classList.remove('active');
    }

    for (let inactiveElem of this.inactiveElems) {
      inactiveElem.classList.remove('inactive');
    }
  }

  burgerToggle() {
    this.html.classList.toggle('o-h');
    this.navBurger.classList.toggle('active');
    this.navMainListWrapper.classList.toggle('active');
  }

  navToggle(navSubLink) {

    let itemParent = navSubLink.closest('.main-nav-list-item');
    let navSubPanel = itemParent.querySelector('.main-nav-sub');
    let alreadyActive = navSubLink.classList.contains('active');

    for (let subLink of this.navSubLinks) {
      subLink.classList.remove('active');
      subLink.closest('.main-nav-list-item').classList.remove('active');
      subLink.closest('.main-nav-list-item').classList.remove('inactive');
    }

    for (let navSubPanel of this.navSubPanels) {
      navSubPanel.classList.remove('active');
    }

    if (!alreadyActive) {
      navSubLink.classList.add('active');
      navSubPanel.classList.add('active');
      itemParent.classList.add('active');

      if (!utils.mq.md.matches) {
        const regionListItems = navSubPanel.querySelectorAll('.region-list-item');
        if (regionListItems.length > 0) {
          if (!navSubPanel.querySelector('.region-list-item.active')) {
            regionListItems[0].classList.add('active');
          }
        }
      }

      for (let navListItem of this.navMainListItem) {
        if (!navListItem.classList.contains('active')) {
          navListItem.classList.add('inactive');
        }
      }
    }
  }

  regionListToggle(regionItem) {
    for (let item of this.regionListItem) {
      if (!item.isSameNode(regionItem)) {
        item.classList.remove('active');
      }
    }

    if (!utils.mq.md.matches) {
      regionItem.classList.add('active');
    }
    else {
      regionItem.classList.toggle('active');
    }

    let targetRegion = regionItem.querySelector('.region');
    let targetRegionHeight = utils.outerHeight(targetRegion);

    if (!utils.mq.md.matches) {
      if (targetRegionHeight > this.regionListWrapperHeight) {
        this.regionListWrapper.style.height = targetRegionHeight + 'px';
      }
    }

    utils.mq.md.addEventListener('change', mq => {
      this.regionListWrapper.style.height = 'auto';
    });

  }

  regionMap() {
    this.region.forEach(region => {
      const map = region.querySelector('.region-map');
      const areas = map.querySelectorAll('.label-area');
      const labels = region.querySelectorAll('.region-area-label');

      for (let label of labels) {
        label.addEventListener('mouseenter', e => {
          let mapLabel = label.dataset.mapLabel;

          for (let area of areas) {
            area.classList.remove('active');
          }

          document.getElementById(`${mapLabel}`).classList.add('active');
        });
      }
    });
  }
}

const mainNav = document.querySelector('#main-nav');
if (mainNav) {
  mainNav.nav = new nav(mainNav);
}

(function setupScrollTopOnBackNavigation() {
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  function scrollToTop() {
    window.scrollTo(0, 0);
  }

  function hideLoader() {
    document.querySelectorAll('.page-loader').forEach(loader => loader.remove());
    document.body.classList.remove('loading', 'o-h');
  }

  function handleNavigation() {
    scrollToTop();
    hideLoader();
  }

  window.addEventListener('popstate', handleNavigation);

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      handleNavigation();
    }
  });
})();
